import { render } from "./ImprintPage.vue?vue&type=template&id=2552c15f"
import script from "./ImprintPage.vue?vue&type=script&lang=js"
export * from "./ImprintPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__